import script from "./GlobalEventSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalEventSelector.vue?vue&type=script&setup=true&lang=js"

import "./GlobalEventSelector.vue?vue&type=style&index=0&id=daffabd6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-daffabd6"]])

export default __exports__